/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminPcc
 */
export interface AdminPcc {
    /**
     * 
     * @type {string}
     * @memberof AdminPcc
     */
    onBehalfOf?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPcc
     */
    onBehalfOfScCode?: string;
}

/**
 * Check if a given object implements the AdminPcc interface.
 */
export function instanceOfAdminPcc(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AdminPccFromJSON(json: any): AdminPcc {
    return AdminPccFromJSONTyped(json, false);
}

export function AdminPccFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminPcc {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'onBehalfOf': !exists(json, 'onBehalfOf') ? undefined : json['onBehalfOf'],
        'onBehalfOfScCode': !exists(json, 'onBehalfOfScCode') ? undefined : json['onBehalfOfScCode'],
    };
}

export function AdminPccToJSON(value?: AdminPcc | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'onBehalfOf': value.onBehalfOf,
        'onBehalfOfScCode': value.onBehalfOfScCode,
    };
}

